import styled, {css} from "styled-components";
import {FaExchangeAlt} from "react-icons/fa";
import {FiChevronLeft} from "react-icons/fi";
import {FlexBetween} from "../CommonStyles";


const ChangePairIcon = styled(FaExchangeAlt)`
  color: ${props => props.theme.color};
  margin-top: -3px;
`

const RTradeCompWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${props => props.theme.tradeBg};
  padding: 10px 0;
  direction: ltr;
`

const CoinWrap = styled.div`
  position: absolute;
  top: ${props => props.top || 0};
  left: ${props => props.left || 0};
  z-index: ${props => props.zIndex || 1};
`

const OrderRow = styled(FlexBetween)`
  border-bottom: 1px solid ${props => props.theme.color}20;
  height: unset;
`

const BackIcon = styled(FiChevronLeft)`
  transform: rotate(0);
  transition: all 0.2s;
  color: ${props => props.theme.primary};
  margin-top: -3px;
  ${props => props.theme.english && css`
    transform: rotate(180deg);
  `};
`

const RFixTradeBtnWrapper = styled.div`
  position: fixed;
  bottom: 60px;
  background-color: ${props => props.theme.secondaryBg};
  height: 50px;
  width: 100%;
  z-index: 102;
  border-top: 1px solid ${props => props.theme.color}15;
`

const RTradeBtn = styled.div`
  width: 40%;
  height: 36px;
  border-radius: 4px;
  box-shadow: 0 0 4px rgb(0, 0, 0, 0.05);
  background-color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed};
  color: #0d1726;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
`

const RDetailTab = styled.div`
  font-size: 0.65rem;
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 12px;
  transition: all 0.2s;
  
  ${props => props.active && css`
    border-bottom: 1px solid ${props => props.theme.mainOrange};
  `};
`

const DepthCircleBox = styled.div`
  background-color: ${props => props.buy ? props => props.theme.mainGreen : props.theme.mainRed };
  width: 8px;
  height: 8px;
  border-radius: 50%;
`

const DepthItem = styled.div`
  color: ${props => props.active ? props.theme.primary : props.theme.color};
  font-size: 0.65rem;
  margin: 0 4px;
`

const DepthItemWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 4px;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  border-bottom: 1px solid ${props => props.theme.color}20;
`

export {
    ChangePairIcon,
    RTradeCompWrap,
    CoinWrap,
    OrderRow,
    BackIcon,
    RFixTradeBtnWrapper,
    RTradeBtn,
    RDetailTab,
    DepthCircleBox,
    DepthItem,
    DepthItemWrapper
}
